import { useId, useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Checkbox, type CheckboxProps } from "@/components/Checkbox/Checkbox";
import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";

type Props = Pick<CheckboxProps, "checked" | "onChange" | "onBlur">;

export function TermsAndConditionsCard({ checked, onBlur, onChange }: Props) {
  const intl = useIntl();
  const checkboxId = useId();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="flex rounded-3xl bg-white p-3">
        <div className="flex gap-2 text-sm">
          <div className="shrink-0">
            <Checkbox
              id={checkboxId}
              checked={checked}
              onChange={onChange}
              onBlur={onBlur}
              disablePadding
            />
          </div>

          <div className="flex flex-col gap-1 pt-1">
            <label
              className="text-sm font-semibold text-text-primary"
              htmlFor={checkboxId}
            >
              {intl.formatMessage({ id: "flights.acceptGeneralTerms" })}
            </label>
            <div className="text-sm text-text-tertiary">
              {intl.formatMessage({ id: "flights.acceptGeneralTermsWarning" })}
            </div>
            <Button
              size="small"
              variant="textFit"
              onClick={() => setMoreDetailsOpen(true)}
            >
              {intl.formatMessage({ id: "moreDetails" })}
            </Button>
          </div>
        </div>
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
}
